import React from 'react';
import TreeList, { Column, FilterRow, Scrolling, SearchPanel, HeaderFilter } from 'devextreme-react/tree-list';
import { SPSyncRow } from '../../../api/v2/SPSyncApi';
import { statusCellRender, differencesCellRender, nameCellRender } from './SPSyncShared';

interface SPSyncTreeListProps {
    rows: SPSyncRow[];
    autoExpandAll?: boolean;
}

const SPSyncTreeList: React.FC<SPSyncTreeListProps> = ({ rows, autoExpandAll = true }) => {
    return (
        <TreeList
            dataSource={rows}
            keyExpr="id"
            parentIdExpr="parentId"
            showBorders={true}
            showColumnLines={false}
            columnAutoWidth={true}
            autoExpandAll={autoExpandAll}
            height={window.innerHeight - 200}
            wordWrapEnabled={true}
            showRowLines={true}
            rowAlternationEnabled={true}
            customizeColumns={(columns: any[]) => {
                columns.forEach((col: any) => { col.cssClass = 'vertical-center'; });
            }}
        >
            <SearchPanel visible={true} width={300} placeholder="Search..." />
            <FilterRow visible={true} />
            <HeaderFilter visible={true} />
            <Scrolling mode="virtual" />
            <Column dataField="name" caption="Name" cellRender={nameCellRender} minWidth={250} />
            <Column dataField="entityType" caption="Type" width={90}>
                <HeaderFilter allowSearch={true} />
            </Column>
            <Column dataField="status" caption="Status" width={100} cellRender={statusCellRender}>
                <HeaderFilter allowSearch={true} />
            </Column>
            <Column dataField="dB_SPId" caption="DB SPId" width={280} visible={true} />
            <Column dataField="sP_UniqueId" caption="SP UniqueId" width={280} visible={true} />
            <Column dataField="dB_SPPath" caption="DB SPPath" visible={false} />
            <Column dataField="sP_Path" caption="SP Path" visible={false} />
            <Column dataField="sP_FolderName" caption="SP Folder" visible={false} />
            <Column dataField="differences" caption="Differences" cellRender={differencesCellRender} minWidth={200} />
        </TreeList>
    );
};

export default SPSyncTreeList;
